<div class="app-payment-has-been-saved">
  <app-image name="success"></app-image>
  <h3 class="text-center" nz-typography translate>payment.saved</h3>
  <div class="buttons">
    <button nz-button nzType="primary" nzSize="large" type="button" (click)="done()" translate>payment.success.done</button>
  </div>
</div>
